<div class="search-wrapper">
    <div class="search">
     
      <input placeholder="Search..." [(ngModel)]="searchTerm" (input)="search()" (keyup)="search()" />
      <mat-icon matPrefix *ngIf="!searchTerm">search</mat-icon>
      <mat-icon matSuffix *ngIf="searchTerm" (click)="clearSearch()">cancel</mat-icon>
    </div>
  </div>